export default __webpack_public_path__ + "static/media/login-bg2.f2b4d728.png";